<h2 class="text-2xl font-bold p-4">Gestisci Templates</h2>

<app-entity-crud-page-template
  [data]="templates"
  [columns]="columns"
  [loading]="loading"
  [totalRecords]="totalRecords"
  [rows]="rows"
  (onLazyLoad)="loadTemplates($event)"
  (onCreate)="saveTemplate()"
  (onDeleteSelected)="deleteSelectedTemplates($event)"
  [enableSearch]="false"
  [enableFilterReset]="true"
/>
